module.exports = __webpack_public_path__ + "img/mickey00.52754da1.jpg";